import axios from "axios";
import { getToken } from "./utilsApi";

/**
 * Client for the standalone support/feedback intake endpoint (/portal/support on the portal API).
 * Separate from the generic /portal/crud client because it isn't a CRUD `{type}` resource.
 *   - submitSupportRequest: any authenticated user (support or feedback item)
 *   - listSupportRequests / updateSupportStatus: super-admin review surface (server-enforced)
 */
// REACT_APP_apiBaseUrl already ends with ".../<stage>/portal/" (the CRUD client builds
// `${base}crud/{type}/` off it), so the support path is just `${base}support`.
const supportUrl = () => `${process.env.REACT_APP_apiBaseUrl}support`;

export const submitSupportRequest = async (payload) => {
  const token = await getToken();
  const res = await axios({
    method: "POST",
    url: supportUrl(),
    headers: { "x-api-key": token, "Content-Type": "application/json" },
    data: payload,
  });
  return res.data;
};

export const listSupportRequests = async () => {
  const token = await getToken();
  const res = await axios({
    method: "GET",
    url: supportUrl(),
    headers: { "x-api-key": token },
  });
  return res.data;
};

export const updateSupportStatus = async (id, status) => {
  const token = await getToken();
  const res = await axios({
    method: "PATCH",
    url: supportUrl(),
    headers: { "x-api-key": token, "Content-Type": "application/json" },
    data: { id, status },
  });
  return res.data;
};
